// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"treemap_wrapper__3zBml","title":"treemap_title__yaVdz"};